var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20.018555,
    viewBox: "0 0 20 20.0186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M5.83 0C2.61 0 0 2.62 0 5.83L0 14.18C0 17.4 2.61 20.01 5.83 20.01L14.16 20.01C17.38 20.01 20 17.39 20 14.17L20 5.83C20 2.61 17.38 0 14.16 0L5.83 0ZM15.83 3.33C16.29 3.33 16.66 3.7 16.66 4.17C16.66 4.63 16.29 5 15.83 5C15.37 5 15 4.63 15 4.17C15 3.7 15.37 3.33 15.83 3.33ZM10 5C12.75 5 15 7.24 15 10C15 12.76 12.75 15.01 10 15.01C7.24 15.01 5 12.76 5 10C5 7.24 7.24 5 10 5ZM10 6.67C9.08 6.67 8.29 6.99 7.64 7.65C6.99 8.3 6.66 9.08 6.66 10C6.66 10.93 6.99 11.71 7.64 12.36C8.29 13.01 9.08 13.34 10 13.34C10.91 13.34 11.7 13.01 12.35 12.36C13 11.71 13.33 10.93 13.33 10C13.33 9.08 13 8.3 12.35 7.65C11.7 6.99 10.91 6.67 10 6.67Z",
    fill: "#7E7E7E",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.121b148e319342185bbea57e53ccc15d.svg";
export { ForwardRef as ReactComponent };